import { render } from "./AcceptedPage.vue?vue&type=template&id=3b01f1cc&scoped=true"
import script from "./AcceptedPage.vue?vue&type=script&lang=js"
export * from "./AcceptedPage.vue?vue&type=script&lang=js"

import "./AcceptedPage.vue?vue&type=style&index=0&id=3b01f1cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b01f1cc"]])

export default __exports__